module.exports = __webpack_public_path__ + "static/img/icon_ping.5e0677d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/icon_ping.png
// module id = W+gY
// module chunks = 0